export const MASTERMIX_PDF_CONFIG = {
  COLUMN_WIDTH: 65,
  COLUMNS_WIDTH: 670,
};
